import { UserInterface } from 'app/core/user/models';

export interface CommentInterface {
  author?: UserInterface;
  id?: number;
  text?: string;
}

export class Comment implements CommentInterface {
  public author?: UserInterface;
  public id?: number;
  public text?: string;

  constructor({
    author = undefined,
    id = undefined,
    text = undefined,
    }: CommentInterface) {
    this.author = author;
    this.id = id;
    this.text = text;
  }
}
